import type { DeleteActionConfig } from "~/core/models/DeleteActionConfig.interface";
import LxcError from "~/core/models/LxcError.class";
import {
  NotificationKey,
  showNotificationSuccess,
} from "~/core/utils/notifications";

export function useDeleteAction(config: DeleteActionConfig) {
  const { t } = useI18n();
  const [deleteConfirmDialogVisible, toggleDeleteConfirmVisible] = useToggle();
  const isLoading = ref(false);

  const successKey =
    config.successNotificationKey ?? NotificationKey.removeSuccess;
  const errorKey = config.errorNotificationKey ?? NotificationKey.removeError;

  const onDeleteConfirm = async () => {
    isLoading.value = true;

    const response = await config.deleteFn();

    if (LxcError.check(response)) {
      response.notify(errorKey as NotificationKey);
    } else {
      showNotificationSuccess(t(successKey));
      if (config.onSuccess) {
        config.onSuccess();
      }
    }
    isLoading.value = false;
    toggleDeleteConfirmVisible(false);
  };

  const onDeleteClick = () => {
    toggleDeleteConfirmVisible(true);
  };

  return {
    deleteConfirmDialogVisible,
    toggleDeleteConfirmVisible,
    onDeleteConfirm,
    onDeleteClick,
    isLoading,
  };
}
